import styled from '@emotion/styled';
import { ItemResponse } from '@models/item';
import { Fragment } from 'react';

import AmountRow from './AmountRow';
import useOrderEnabled from './hooks/useOrderEnabled';
import OrderRow from './OrderRow';

interface Props {
    shopId: string;
    isSoldOut: boolean;
    item: ItemResponse;
}

function ItemFooter({ item, shopId, isSoldOut }:Props) {
    const itemId = item.id;
    const isOrderEnabled = useOrderEnabled(shopId);
    if (isOrderEnabled) {
        return (
            <Container>
                <AmountRow itemId={itemId} />
                <OrderRow shopId={shopId} isSoldOut={isSoldOut} item={item} />
            </Container>
        );
    }
    return (<Fragment/>);
}

const Container = styled.footer`
    width: 100%;
`;

export default ItemFooter;
